import { PayrocAccount } from '../admin/store';

export class PayrocAccountViewModel {
    public tenantId: number = 0;
    public enterpriseId: number = 0;
    public storeId: number = 0;
}

export class PayrocAccountListViewModel extends PayrocAccountViewModel {
    public accounts: PayrocAccount[] = [];
}

export class PayrocAccountAddOrUpdateViewModel extends PayrocAccountViewModel {
    public account: PayrocAccount = {};
    public id: string = '';
}
